import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  NitroTextField,
  NitroToggle,
  NitroPanel,
  NitroHeading,
} from 'nitro-components';
import { debounce } from 'lodash';
import { SelectField, MenuItem, AutoComplete } from 'material-ui';
import { MuiThemeProvider, getMuiTheme } from 'material-ui/styles';

import { colorPalette } from '@src/themes/theme-material-ui';
import AdminAPI from '@src/api/AdminApi';
import UserApi from '@src/api/UserApi';

const autoCompleteTheme = getMuiTheme({
  textField: {
    disabledTextColor: '#bbb',
    borderColor: '#bbb',
    focusColor: colorPalette.colorSecondary,
  },
});

export const UserDetailSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const UserSection = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
`;

export const InputLabel = styled.label`
  font-size: 12px;
  color: ${props => {
    if (typeof props.valid === 'undefined' || props.valid) {
      return props.theme.color.base1;
    }
    return 'red';
  }};
  margin-bottom: 8px;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: 30px;
`;

class UserDetails extends Component {
  static propTypes = {
    userId: PropTypes.string.isRequired,
    zoneName: PropTypes.string,
    BizEntityDataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChangeBusinessEntity: PropTypes.func.isRequired,
  };

  static defaultProps = {
    zoneName: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isNew: false,
      bizEntityKey: '',
      userName: '',
      firstName: '',
      lastName: '',
      employerCompanyName: '',
      mobile: '',
      businessEntityName: '',
      businessEntityId: '',
      countryCode: '',
      employerDataSource: [],
      bizEntityDataSource: [],
      isActive: true,
      zoneName: '',
      timezones: [],
    };
    this.onFieldChange = this.onFieldChange.bind(this);
    this.businessEntities = [];
  }

  componentWillMount() {
    const { user, BizEntityDataSource, zoneName } = this.props;

    let newState = {
      bizEntityDataSource: BizEntityDataSource,
      zoneName,
    };

    if (BizEntityDataSource.length === 1) {
      const sel = BizEntityDataSource[0];
      newState = Object.assign({}, newState, {
        businessEntityId: sel.Id,
        businessEntityName: sel.Name,
      });
    }

    if (this.props.userId === 'new') {
      newState = Object.assign({}, newState, { isNew: true });
    } else {
      newState = Object.assign({}, newState, {
        userName: user.userName,
        firstName: user.firstName,
        lastName: user.lastName,
        countryCode: user.countryCode,
        employerCompanyCode: user.employerCompanyCode,
        employerCompanyName: user.employerCompanyName,
        mobile: user.mobile,
        businessEntityName: user.businessEntityName,
        businessEntityId: user.businessEntityId,
        isActive: user.isActive,
        zoneId: user.zoneId,
        zoneName: user.zoneName,
      });

      this.getTimzeZones(user.countryCode);
    }

    this.setState(newState);
  }

  onFieldChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  extractTimeZone = zoneName => {
    const { timezones } = this.state;
    const timezone = timezones.find(z => z.zoneName === zoneName);
    return timezone;
  };

  onChangeCountryCode = countryCode => {
    this.getTimzeZones(countryCode);
  };

  getTimzeZones = countryCode => {
    if (countryCode)
      UserApi.getTimeZones(countryCode)
        .then(data => {
          this.setTimeZone(data);
        })
        .catch(err => err);
  };

  setTimeZone = timezones => {
    this.setState({
      timezones,
    });
  };

  getEmployers = (businessEntityId, searchText) =>
    AdminAPI.getEmployer(businessEntityId, this.state.countryCode, searchText)
      .then(data => {
        if (data.length === 1) {
        }
        this.setState({
          employerDataSource: data,
        });
      })
      .catch(err => {
        throw err;
      });

  getValue() {
    return this.state;
  }

  extractBizEntity = selkey => {
    const { bizEntityDataSource } = this.state;
    const bizEnt = bizEntityDataSource.find(x => x.EntityKey === selkey);
    return bizEnt;
  };

  toggleAction = (e, toggled) => {
    this.setState({
      isActive: toggled,
    });
  };

  render() {
    const {
      isNew,
      bizEntityKey,
      businessEntityId,
      firstName,
      lastName,
      userName,
      mobile,
      isActive,
      businessEntityName,
      employerCompanyName,
      employerCompanyCode,
      bizEntityDataSource,
      employerDataSource,
      timezones,
      zoneName,
      countryCode,
    } = this.state;

    return (
      <NitroPanel>
        <NitroHeading label="User Details" size="1" variant="secondary" />

        <UserDetailSection>
          <UserSection>
            <NitroTextField
              floatingLabelText="Username"
              value={userName}
              variant="base1"
              fullWidth
              onChange={event =>
                this.onFieldChange('userName', event.target.value)
              }
              disabled={!isNew}
            />

            <NitroTextField
              floatingLabelText="First name"
              value={firstName}
              onChange={event => {
                this.onFieldChange('firstName', event.target.value);
              }}
              fullWidth
              variant="base1"
              props
            />
            <NitroTextField
              floatingLabelText="Last name"
              value={lastName}
              onChange={event =>
                this.onFieldChange('lastName', event.target.value)
              }
              variant="base1"
              fullWidth
            />

            <NitroTextField
              floatingLabelText="Mobile number"
              value={mobile || ''}
              variant="base1"
              fullWidth
              onChange={event =>
                this.onFieldChange('mobile', event.target.value)
              }
            />
          </UserSection>

          <UserSection>
            {isNew && (
              <div>
                <SelectField
                  floatingLabelText="Business Entity"
                  fullWidth
                  value={bizEntityKey}
                  // lock be selector if in edit mode, e.g. userId exist
                  onChange={(event, key, payload) => {
                    this.onFieldChange('bizEntityKey', payload);
                    const bizEnt = this.extractBizEntity(payload);

                    this.onFieldChange('businessEntityName', bizEnt.Name);
                    this.onFieldChange('businessEntityId', bizEnt.Id);
                    this.onFieldChange('countryCode', bizEnt.CountryCode);
                    this.onFieldChange('countryId', bizEnt.CountryId);
                    this.props.onChangeBusinessEntity(
                      bizEnt.Id,
                      bizEnt.CountryCode
                    );
                    this.onChangeCountryCode(bizEnt.CountryCode);
                  }}>
                  {bizEntityDataSource &&
                    bizEntityDataSource.map((ea, idx) => (
                      <MenuItem
                        key={`biz_ent${idx}`}
                        value={ea.EntityKey}
                        primaryText={`${
                          ea.Name
                        } - ${ea.CountryCode.toUpperCase()}`}
                      />
                    ))}
                </SelectField>
                <MuiThemeProvider muiTheme={autoCompleteTheme}>
                  <AutoComplete
                    floatingLabelText="Employer"
                    disabled={!businessEntityId}
                    fullWidth
                    dataSourceConfig={{
                      text: 'displayName',
                      value: 'CompanyCode',
                    }}
                    filter={AutoComplete.noFilter}
                    openOnFocus
                    dataSource={
                      employerDataSource
                        ? employerDataSource.map(employer => ({
                            ...employer,
                            displayName: `${employer.CompanyName} (${
                              employer.CompanyCode
                            })`,
                          }))
                        : []
                    }
                    onUpdateInput={debounce(searchText => {
                      if (searchText.length > 1)
                        this.getEmployers(businessEntityId, searchText);
                    }, 500)}
                    onNewRequest={(chosenRequest, index) => {
                      // console.log(chosenRequest);
                      this.onFieldChange(
                        'employerCompanyCode',
                        chosenRequest.CompanyCode
                      );
                      this.onFieldChange(
                        'employerCompanyName',
                        chosenRequest.CompanyName
                      );
                    }}
                    textFieldStyle={{
                      color: '#bbb',
                    }}
                  />
                </MuiThemeProvider>
              </div>
            )}

            {!isNew && (
              <div>
                <NitroTextField
                  floatingLabelText="Business Entity"
                  value={
                    businessEntityName
                      ? `${businessEntityName} - ${this.state.countryCode.toUpperCase()}`
                      : ''
                  }
                  disabled
                  variant="base1"
                  fullWidth
                />

                <NitroTextField
                  floatingLabelText="Employer"
                  value={
                    `${employerCompanyName} (${employerCompanyCode})` || ''
                  }
                  variant="base1"
                  fullWidth
                  disabled
                />
              </div>
            )}

            <SelectField
              floatingLabelText="Time Zones"
              fullWidth
              disabled={!countryCode}
              value={zoneName}
              floatingLabelStyle={{
                color: '#0000004d',
              }}
              selectedMenuItemStyle={{
                color: '#bbbbbb',
              }}
              underlineStyle={{
                borderBottomColor: '#0000004d',
              }}
              onChange={(event, key, payload) => {
                this.onFieldChange('zoneName', payload);
                const zone = this.extractTimeZone(payload);
                this.onFieldChange('zoneId', zone.zoneId);
              }}>
              {timezones.length > 0 &&
                timezones.map((ea, idx) => {
                  const gmtOffset = ea.gmtOffset / 3600;
                  let text = '';
                  if (gmtOffset > 0) {
                    text = `(GMT + ${gmtOffset}) ${ea.zoneName}`;
                  } else {
                    text = `(GMT - ${gmtOffset}) ${ea.zoneName}`;
                  }
                  return (
                    <MenuItem
                      key={`timeZone_${ea.zoneId}`}
                      value={ea.zoneName}
                      primaryText={text}
                    />
                  );
                })}
            </SelectField>
            <InputContainer>
              <NitroToggle
                activeLabel="Active user"
                label="Inactive User"
                toggled={isActive}
                action={this.toggleAction}
              />
            </InputContainer>
          </UserSection>
        </UserDetailSection>
      </NitroPanel>
    );
  }
}

export default UserDetails;



// WEBPACK FOOTER //
// ./src/features/admin/components/UserDetails.js